import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import 'styles/d3/textarea.scss'

// This is an autosizing textarea component

const Textarea = React.forwardRef((props, ref) => {
  if (!ref) {
    ref = useRef(null)
  }
  const _props = { ...props }
  delete _props.hasError
  const { className, disabled, hasError, onChange } = _props
  const resize = () => {
    const el = ref.current
    el.style.height = 'auto'
    el.style.minheight = `${el.scrollHeight + 5}px`
  }
  const onTextChange = e => {
    resize()
    if (onChange) onChange(e.target.value)
  }

  useEffect(() => {
    resize()
  }, [])

  let textAreaClassName = `d3-textarea ${className || ''}`
  textAreaClassName += hasError ? ' has-error' : ''
  return (
    <textarea
      {..._props}
      disabled={disabled}
      className={textAreaClassName}
      spellCheck
      rows='1'
      ref={ref}
      onChange={onTextChange}
    />
  )
})

Textarea.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
}

export default Textarea



// WEBPACK FOOTER //
// ./src/components/Textarea.js